import { db } from '../lib/firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';

export const getUserProfile = async (userId) => {
  try {
    const userDoc = await getDoc(doc(db, 'users', userId));
    if (userDoc.exists()) {
      const data = userDoc.data();
      return {
        success: true,
        data: {
          ...data,
          timeline: data.timeline || [], // Ensure timeline exists
          about: data.about || '',
          skills: data.skills || [],
          achievements: data.achievements || [],
          company: data.company || '',
          location: data.location || '',
          name: data.name || '',
          department: data.department || '',
          batch: data.batch || '',
          profilePic: data.profilePic || ''
        }
      };
    }
    return {
      success: false,
      error: 'User not found'
    };
  } catch (error) {
    console.error('Error fetching user profile:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

export const updateUserBasicInfo = async (userId, updateData) => {
  try {
    const userRef = doc(db, 'users', userId);
    await updateDoc(userRef, updateData);
    return {
      success: true
    };
  } catch (error) {
    console.error('Error updating user basic info:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

export const updateUserProfileSection = async (userId, section, data) => {
  try {
    const userRef = doc(db, 'users', userId);
    await updateDoc(userRef, {
      [section]: data
    });
    return {
      success: true
    };
  } catch (error) {
    console.error(`Error updating ${section}:`, error);
    return {
      success: false,
      error: error.message
    };
  }
};
